import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Row, Col } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const TabCartoes = ({ codigoFamilia }) => {
  const [cartoes, setCartoes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [cartoesOptions, setCartoesOptions] = useState([]);
  const [cartaoSelected, setCartaoSelected] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const carregarCartoes = () => {
    setCarregando(true);
    api.listarCartoesEmpreendimentoConfig(codigoFamilia)
      .then((res) => {
        const dados = res && res.data ? res.data : (res || []);
        setCartoes(Array.isArray(dados) ? dados : []);
      })
      .catch((err) => {
        const msg = err && err.message ? err.message : 'Erro ao carregar cartões';
        toast.error(msg);
      })
      .finally(() => { setCarregando(false); });
  };

  useEffect(() => {
    if (codigoFamilia != null) {
      carregarCartoes();
    }
  }, [codigoFamilia]);

  useEffect(() => {
    if (!showForm) return;
    api.listarCartoesLookupConfig()
      .then((res) => {
        const dados = res && res.data ? res.data : (res || []);
        const todos = Array.isArray(dados) ? dados : [];
        const codigos = cartoes.map((c) => c.codigo);
        const disponiveis = todos.filter((c) => codigos.indexOf(c.codigo) === -1);
        const opts = disponiveis.map((c) => ({
          value: c.codigo,
          label: c.codigo + ' - ' + c.descricao + (c.taxa != null ? ' (' + c.taxa + '%)' : ''),
        }));
        setCartoesOptions(opts);
      })
      .catch(() => { toast.error('Erro ao carregar lista de cartões'); });
  }, [showForm, cartoes]);

  const handleIncluir = () => {
    if (cartaoSelected == null) {
      toast.error('Selecione um cartão.');
      return;
    }
    setSalvando(true);
    api.incluirCartaoEmpreendimentoConfig({
      codigo_familia: codigoFamilia,
      codigo_cartao: cartaoSelected.value,
    })
      .then(() => {
        toast.success('Cartão vinculado!');
        setShowForm(false);
        setCartaoSelected(null);
        carregarCartoes();
      })
      .catch((err) => {
        const msg = err && err.message ? err.message : 'Erro ao vincular cartão';
        toast.error(msg);
      })
      .finally(() => { setSalvando(false); });
  };

  const handleExcluir = (item) => {
    if (!window.confirm('Desvincular o cartão "' + item.descricao + '"?')) return;
    api.excluirCartaoEmpreendimentoConfig({
      codigo_familia: codigoFamilia,
      codigo_cartao: item.codigo,
    })
      .then(() => {
        toast.success('Cartão desvinculado!');
        carregarCartoes();
      })
      .catch((err) => {
        const msg = err && err.message ? err.message : 'Erro ao desvincular cartão';
        toast.error(msg);
      });
  };

  return (
    <Row className="justify-content-center">
      <Col md={8}>
        <Card className="mb-3">
          <Card.Header className="d-flex justify-content-between align-items-center py-2">
            <strong>Cartões Vinculados</strong>
            <span className="text-muted small">{cartoes.length} cartão(ões)</span>
          </Card.Header>
          <Card.Body className="p-2">
            {!showForm && (
              <Button size="sm" variant="outline-success" className="mb-2" onClick={() => { setShowForm(true); }}>
                <FaPlus className="mr-1" /> Vincular Cartão
              </Button>
            )}
            {showForm && (
              <div className="p-3 mb-2 border rounded bg-light">
                <Row>
                  <Col md={6}>
                    <label className="small">Cartão *</label>
                    <Select
                      options={cartoesOptions}
                      value={cartaoSelected}
                      onChange={setCartaoSelected}
                      placeholder="Selecione o cartão..."
                      isClearable
                    />
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                      <FaPlus className="mr-1" /> Vincular
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => { setShowForm(false); setCartaoSelected(null); }} disabled={salvando}>
                      Cancelar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {carregando && <p className="text-muted small">Carregando...</p>}
            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
              <Table striped bordered hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>Código</th>
                    <th>Descrição</th>
                    <th style={{ width: 100 }}>Taxa (%)</th>
                    <th style={{ width: 80 }}>Dias</th>
                    <th style={{ width: 60 }}>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {cartoes.length === 0 && !carregando && (
                    <tr>
                      <td colSpan={5} className="text-center text-muted">
                        Nenhum cartão associado
                      </td>
                    </tr>
                  )}
                  {cartoes.map((item) => (
                    <tr key={item.codigo}>
                      <td>{item.codigo}</td>
                      <td>{item.descricao}</td>
                      <td>{item.taxa != null ? item.taxa : '-'}</td>
                      <td>{item.dias != null ? item.dias : '-'}</td>
                      <td>
                        <Button size="sm" variant="outline-danger" title="Desvincular" onClick={() => { handleExcluir(item); }}>
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default TabCartoes;
